/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Edit_TitleInputs */

const es_feedback_modal_edit_title = /** @type {(inputs: Feedback_Modal_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Feedback`)
};

const en_feedback_modal_edit_title = /** @type {(inputs: Feedback_Modal_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Feedback`)
};

/**
* | output |
* | --- |
* | "Edit Feedback" |
*
* @param {Feedback_Modal_Edit_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_edit_title = /** @type {((inputs?: Feedback_Modal_Edit_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Edit_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_edit_title(inputs)
	return en_feedback_modal_edit_title(inputs)
});
export { feedback_modal_edit_title as "feedback.modal.edit_title" }